import { Typography } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import theme from 'src/config/theme';

import { usePostSearchResultMutation } from 'src/store/search-content/searchContentApi';
import { SearchContent } from 'src/store/search-content/type';

export const TOCSearchResults: FC = () => {
  const [, response] = usePostSearchResultMutation({ fixedCacheKey: 'toc-search' });

  const [newResponse, setNewResponse] = useState<null | SearchContent[]>(null);

  useEffect(() => {
    if (response) {
      if (response.error) {
        setNewResponse(response.error as SearchContent[]);
      } else if (response.data) {
        setNewResponse(response.data as SearchContent[]);
      }
    }
  }, [response]);

  return (
    <>
      {newResponse &&
        newResponse.map((item: SearchContent) => {
          return (
            <div
              style={{
                display: 'flex',
                gap: 8,
                flexDirection: 'column',
                backgroundColor: theme.palette.white,
                borderRadius: 8,
                padding: 16,
                cursor: 'pointer',
              }}
              onClick={() => alert('here you will access a trajectory')}
            >
              <div style={{ display: 'flex', gap: 8 }}>
                {item.chapters.map((chapter, chapterIndex) => {
                  return (
                    <>
                      <Typography variant="subtitle2">
                        {`${chapter.number} ${chapter.title} `}
                      </Typography>
                      <Typography variant="subtitle2">
                        {item.chapters.length - 1 === chapterIndex ? '' : '>'}
                      </Typography>
                    </>
                  );
                })}
              </div>
              <div
                style={{
                  display: 'flex',
                  gap: 8,
                  flexDirection: 'row',
                }}
              >
                <Typography variant="body1" style={{ color: theme.palette.primary.main }}>
                  {item.trajectory.number}
                </Typography>
                <Typography variant="body1" style={{ fontWeight: 700 }}>
                  {item.trajectory.title}
                </Typography>
              </div>
            </div>
          );
        })}
    </>
  );
};
